import React from 'react';
import {
	Col,
	Descriptions,
	Row,
} from 'antd';
import {
	PortActionTypes,
	VoyageBunkerTypes,
} from '@shared/utils/constants';
import DatePicker from '@client/components/DatePicker';
import { ItineraryPortCallDto } from '@client/screens/estimates/details/helpers/types';
import BunkersTable from '@client/components/BunkersTable/BunkersTable';
import { useVoyage } from '@client/screens/fleet/VoyageDetailsScreen/components/VoyageProvider/VoyageProvider';
import { useItinerary } from '../ItineraryProvider';

const PortCallDeliveryRedeliveryTab = () => {
	const {
		expandedEntry,
	} = useItinerary();

	const {
		voyageDetails,
		updateVoyageField,
		refreshVoyageDetails,
		fixtureCurrency,
	} = useVoyage();

	if (expandedEntry == null) {
		return (<b>Could not find entry</b>);
	}

	const selectedPortCall = expandedEntry as ItineraryPortCallDto;

	const actionType = selectedPortCall.actions.some((a) => a.event === PortActionTypes.DELIVERY) ?
		PortActionTypes.DELIVERY :
		PortActionTypes.REDELIVERY;

	const label = actionType === PortActionTypes.DELIVERY ? 'Delivery' : 'Redelivery';

	const port = actionType === PortActionTypes.DELIVERY ?
		voyageDetails.deliveryPort :
		voyageDetails.redeliveryPort;

	const date = actionType === PortActionTypes.DELIVERY ?
		voyageDetails.deliveryDate :
		voyageDetails.redeliveryDate;

	const estimatedDate = actionType === PortActionTypes.DELIVERY ?
		voyageDetails.deliveryDate : voyageDetails.estimatedCompletionDate;

	const fieldToUpdate = actionType === PortActionTypes.DELIVERY ? 'deliveryDate' : 'redeliveryDate';

	const deliveryBunkers = voyageDetails.voyageBunkers.filter((vb) => (
		vb.type === VoyageBunkerTypes.DELIVERY
	));

	const redeliveryBunkers = voyageDetails.voyageBunkers.filter((vb) => (
		vb.type === VoyageBunkerTypes.REDELIVERY ||
		vb.type === VoyageBunkerTypes.OWNERS_ACCOUNT
	));

	const bunkers = actionType === PortActionTypes.DELIVERY ?
		deliveryBunkers :
		redeliveryBunkers;

	const singleType = actionType === PortActionTypes.DELIVERY ?
		VoyageBunkerTypes.DELIVERY :
		VoyageBunkerTypes.REDELIVERY;

	return (
		<Row>
			<Col span={24}>
				<Descriptions
					bordered
					column={2}
					items={[
						{
							label: `${label} port`,
							children: port?.name ?? 'Not specified',
							span: 2,
						},
						{
							label: `Estimated ${label} date`,
							span: 2,
							children: (
								<DatePicker
									placeholder={`Estimated ${label} date`}
									defaultValue={estimatedDate}
									time
									disabled
								/>
							),
						},
						{
							label: `${label} date`,
							span: 2,
							children: (
								<DatePicker
									placeholder={`Select ${label} date`}
									defaultValue={date}
									time
									onChange={(value) => updateVoyageField(fieldToUpdate, value)}
								/>
							),
						},
					]}
				/>
			</Col>
			<Col span={24}>
				<BunkersTable
					bunkers={bunkers}
					voyageId={voyageDetails.id}
					tcTermsId={voyageDetails.tcTerms?.id}
					refreshDetails={refreshVoyageDetails}
					currency={fixtureCurrency}
					variant="single"
					singleType={singleType}
					availableFuelGrades={voyageDetails.vesselFuelGrades}
					showOtherTable={false}
				/>
			</Col>
		</Row>
	);
};

export default PortCallDeliveryRedeliveryTab;
